import script from "./LoginModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginModal.vue?vue&type=script&setup=true&lang=js"

import "./LoginModal.vue?vue&type=style&index=0&id=730b43aa&lang=less"

const __exports__ = script;

export default __exports__